import { useState } from "react";
import { PointOfSale } from "@mui/icons-material";
import { Box, Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import CircularProgressCustom from "../CircularProgressCustom";
import CashRegisterView from "../CashRegister";
import NumberInputDialog from "./NumberInput";

const CashRegister = ({ 
  store,
  data,
  openCashRegister,
  onOpenCashRegister,
  onOpenningCashRegister,
  onClossingCashRegister, 
  onCancel,
  loading,
  onSave, 
  onCloseCashRegister,
  backgroundColor 
}) => {
  const cashRegisterInital = {
    store_id: store._id,
    detail_cash_register: {
      initial_mount: 0,
      cash_sale_total: 0,
      trans_sale_total: 0,
      total_income: 0,
      total_expenses: 0,
      final_cash_amount: 0,
      expected_cash_amount: 0,
      difference: 0
    }
  }

  const [openCreateCash, setOpenCreateCash] = useState(false);
  const [openCashReal, setOpenCashReal] = useState(false);
  const [openCashExpected, setOpenCashExpected] = useState(false);
  const [pendingNewCashAfterExpected, setPendingNewCashAfterExpected] = useState(false);

  // const [openCashRegister, setOpenCashRegister] = useState(false);

  return <>
    <Button
      variant="outlined"
      color="warning"
      startIcon={<PointOfSale />}
      onClick={() => {
        const hasExpectedAmount = Number(data?.detail_cash_register?.expected_cash_amount || 0) > 0

        if (data == null || (data?.status === "CLOSED" && hasExpectedAmount)) {
          setOpenCreateCash(true)
          return
        }
        onOpenCashRegister && onOpenCashRegister()
      }}
      sx={{
        borderRadius: 2,
        textTransform: 'none',
        boxShadow: 3,
      }}
    >Caja (F3)</Button>
    <NumberInputDialog 
      open={openCreateCash}
      onConfirm={async (valueInitial) => {
        cashRegisterInital.detail_cash_register.initial_mount = valueInitial
        setOpenCreateCash(false)
        onOpenningCashRegister && onOpenningCashRegister(cashRegisterInital)
      }}
      onClose={() => {
        setOpenCreateCash(false)
        onCancel && onCancel()
      }}
    />
    <Dialog 
      open={openCashRegister} 
      maxWidth="lg" 
      fullWidth
    >
      {/* {saving || loading ? <CircularProgressCustom size={150} /> : newSale && !moreOneArticle &&  */}
      <DialogContent>
        <Box display='flex' flexDirection='column' width='100%' justifyItems='center'>
          {loading ? <CircularProgressCustom size={250}/> : 
            <CashRegisterView 
              data={data}
              onCashReal={() => setOpenCashReal(true)}
              onExpectedCash={() => setOpenCashExpected(true)}
              onCloseCashRegister={() => setOpenCashReal(true)}
              onOpenNewCashRegister={() => {
                setPendingNewCashAfterExpected(true)
                setOpenCashExpected(true)
              }}
            />
          }
        </Box>
      </DialogContent>
      <DialogActions >
        <Button onClick={() => onSave && onSave()}> Guardar </Button>
        <Button onClick={() => onCancel && onCancel()}> Cancelar </Button>
      </DialogActions>
    </Dialog>
    <NumberInputDialog 
      tittle='Ingrese cantidad real contada'
      label='Monto contado'
      open={openCashReal}
      onClose={() => setOpenCashReal(false)}
      onConfirm={(value) => {
        var cr = {
          ...data,
          detail_cash_register: {
            ...data.detail_cash_register,
            final_cash_amount: value,
            difference: value - data.detail_cash_register.expected_cash_amount 
          }
        }
        setOpenCashReal(false)
        onClossingCashRegister && onClossingCashRegister(cr)
        onCloseCashRegister && onCloseCashRegister(cr)
      }}
    />
    <NumberInputDialog 
      ittle='Ingrese cantidad esperada'
      label='Monto esperado'
      open={openCashExpected}
      onClose={() => {
        setOpenCashExpected(false)
        setPendingNewCashAfterExpected(false)
      }}
      onConfirm={(value) => {
        var cr = {
          ...data,
          detail_cash_register: {
            ...data.detail_cash_register,
            expected_cash_amount: value,
            difference: data.detail_cash_register.final_cash_amount - value
          }
        }
        setOpenCashExpected(false)
        onClossingCashRegister && onClossingCashRegister(cr)
        if (pendingNewCashAfterExpected) {
          setPendingNewCashAfterExpected(false)
          Promise.resolve(onCloseCashRegister && onCloseCashRegister(cr)).finally(() => {
            setOpenCreateCash(true)
          })
        }
      }}
    />
  </>
}

export default CashRegister;